/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fx_flat_tree .mat-tree-node input[type=checkbox]{width:16px;height:16px;position:relative;margin-left:5px;margin-right:3px}.fx_flat_tree .mat-tree-node input[type=checkbox]::before{background:url(checkbox.2543065cdca3efa9e245.svg) -1px -1px no-repeat;position:absolute;content:'';top:1px;width:14px;height:14px}.fx_flat_tree .mat-tree-node input[type=checkbox]:checked::before{background:url(checkboxed.89ba4dddfdc67075ff04.svg) -1px -1px no-repeat;position:absolute;content:'';top:1px;width:14px;height:14px}"];
export { styles as styles };
